import { Component, OnInit } from '@angular/core';
import { BaseComponentService } from '../../../../services/base-component.service';
import { AslibGridComponent } from '@aslib/components';
import { Empenho } from './../../../../models/pagamento/empenho';

@Component({
  selector: 'gpa-liq-empenho-nao-processado',
  templateUrl: './nao-processado-liq-empenho.component.html',
  providers: [BaseComponentService]
})

export class NaoProcessadoLiqEmpenhoComponent extends BaseComponentService implements OnInit {

  listaNaoProcessado: Empenho[];
  desabilitarReenviar: boolean;
 
  ngOnInit() {

    this.listaNaoProcessado = [];
    this.desabilitarReenviar = true;

    if (sessionStorage.getItem('IdEmp') != null) {
      const emp = Number(sessionStorage.getItem('IdEmp'));
      this.getEmpsNaoProcessados(emp);
    } 
  }

  getEmpsNaoProcessados(fileId: number) {

    const rota = '/api/EmpRetorno/ObterEmpsRetornados'.concat(`/${fileId}/${false}`);

    this._service.routePrefix = rota;

    this.aslibLoadingService.start();

    this.subListar = this._service.getAll('gpa').subscribe(data => {
      this.aslibLoadingService.complete();

      const listaEmpenhoRetorno = data;

      if (listaEmpenhoRetorno) {

        listaEmpenhoRetorno.forEach(emp => {
          const empRetorno: Empenho = new Empenho();

          empRetorno.codigoProjeto = emp.codigoProjeto;
          empRetorno.anoExercicio = emp.anoExercicio;
          empRetorno.cnpjCpfCredor = emp.cnpjCpfCredor;
          empRetorno.nomeCredor = emp.nomeCredor;
          empRetorno.numeroProcessoSEI = emp.numeroProcessoSEI;
          empRetorno.NumPedEmp = emp.numPed;
          empRetorno.valorEmpenho = emp.valorEmpenho;
          empRetorno.mensagemErro = emp.mensagemErro;
          empRetorno.reenviado = false;

          this.listaNaoProcessado.push(empRetorno);

          this.desabilitarReenviar = false;
        });

      } else {
        this.desabilitarReenviar = true;
        this.exibirAviso('Arquivo em processamento.');
      }

    },
      (error) => {
        this.aslibLoadingService.complete();
        this.exibirErro(error);
      },
      () => {
        this.aslibLoadingService.complete();
      }
    );

  }

  reenviarEMP(grid: AslibGridComponent) {
    if (this.listaNaoProcessado.length === 0) {
      this.exibirAviso('Não há dados para a geração e envio do EMP.');
      return;
    }

    this.aslibLoadingService.start();

    this._service.routePrefix = '/api/EmpEnvio/Reenviar';
    this.subSave = this._service.add(this.listaNaoProcessado, 'gpa').subscribe(data => {

      // atualiza a coluna de sinalização de envio.
      for (let index = 0; index < this.listaNaoProcessado.length; index++) {
        this.listaNaoProcessado[index].reenviado = true;
      }

      this.desabilitarReenviar = true;

      this.exibirSucesso('Os EMPs foram reenviados com sucesso.');
    },
      erro => {
        this.aslibLoadingService.complete();
        this.exibirErro(erro);
      },
      () => {
        this.aslibLoadingService.complete();
      }
    );
  }

}


// WEBPACK FOOTER //
// ./src/app/pagamento/liq-pagamento/liq-empenho/nao-processado/nao-processado-liq-empenho.component.ts